import { InsertRowLeftOutlined, UndoOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, patchRequest } from "../../axios";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { confirmAlert } from "react-confirm-alert";

const DepoManagerLoginList = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pickupPointList, setpickupPointList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const { Option } = Select;
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getpickupPointList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(
          "pickup-point/package-by-pickup-point/",
          state
        );

        if (apiResponse?.data?.success) {
          setpickupPointList(apiResponse?.data?.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_depomanager_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getpickupPointList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "additional_detail" && sortOrder === "ascend") {
      sortingEnumKey = "additional_detail";
    }
    if (sortField === "additional_detail" && sortOrder === "descend") {
      sortingEnumKey = "-additional_detail";
    }
    if (sortField === "pincode" && sortOrder === "ascend") {
      sortingEnumKey = "pincode";
    }
    if (sortField === "pincode" && sortOrder === "descend") {
      sortingEnumKey = "-pincode";
    }

    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb";
    }

    if (sortField === "address" && sortOrder === "ascend") {
      sortingEnumKey = "address";
    }
    if (sortField === "address" && sortOrder === "descend") {
      sortingEnumKey = "-address";
    }

    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }

    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "person_name" && sortOrder === "ascend") {
      sortingEnumKey = "person_name";
    }
    if (sortField === "person_name" && sortOrder === "descend") {
      sortingEnumKey = "-person_name";
    }
    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state";
    }
    return sortingEnumKey;
  };

  const handleStatus = async (user_id, status) => {
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("pop_depomanager_status_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(user_id, status),
        },
        {
          label: t("confirmAlert_cancel"),
          onClick: () => navigate("/pickup-point"),
        },
      ],
    });
  };

  const changeStatus = async (id, value) => {
    setLoading(true);
    await patchRequest(`pickup-point-status-change/${id}/`, { status: value })
      .then((response) => {
        SuccessNotificationMsg(t("status_updated_sucessfully"));
        // Use a function updater for setReload to reliably toggle the reload state
        setReload((prevReload) => !prevReload);
      })
      .catch((error) => {
        // Handle error here (e.g., show an error notification)
        console.error("Error updating status:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [checkedList, setCheckedList] = useState([
    "person_name",
    "email",
    "address",
    "phone",
    "suburb",
    "operation",
    "state",
    "pincode",
    "additional_detail",
    "status",
  ]);
  const [columns, setColumns] = useState([
    {
      title: "Name",
      dataIndex: "person_name",
      key: "person_name",
      sorter: true,
      width: 100,
      render: (dataIndex) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "none",
          }}
        >
          {dataIndex}
        </div>
      ),
    },

    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
      sorter: true,
      width: 200,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   // title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        //   title={<span style={{ color: "#fff" }}>{dataIndex?.toLowerCase()}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "lowercase",
          }}
        >
          {dataIndex?.toLowerCase()}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      width: 180,
      render: (phone) => {
        if (phone) {
          const cleanedPhone = String(phone).replace(/\D/g, "");

          if (cleanedPhone.startsWith("91")) {
            return `+91 ${cleanedPhone.slice(2, 7)} ${cleanedPhone.slice(7)}`;
          } else if (cleanedPhone.length > 5) {
            const countryCode = cleanedPhone.slice(0, cleanedPhone.length - 10);
            const localNumber = cleanedPhone.slice(-10);
            return `+${countryCode} ${localNumber.slice(
              0,
              5
            )} ${localNumber.slice(5)}`;
          } else {
            return `+${cleanedPhone}`;
          }
        }
        return null;
      },

      sorter: true,
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: true,
      width: 130,
    },
    {
      title: "Suburb",
      dataIndex: "suburb",
      key: "suburb",
      sorter: true,
      width: 130,
    },
    {
      title: "Pincode",
      dataIndex: "pincode",
      key: "pincode",
      sorter: true,
      width: 130,
    },
    {
      title: "Additional Detail",
      dataIndex: "additional_detail",
      key: "additional_detail",
      sorter: true,
      width: 130,
    },

    // {
    //   title: "Note",
    //   dataIndex: "company_note",
    //   key: "company_note",
    //   sorter: true,
    //   width: 130,
    //   render: (dataIndex) => (
    //     <Tooltip
    //       color={colors}
    //       placement="left"
    //       title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
    //     >
    //       <div
    //         style={{
    //           maxWidth: "400px",
    //           whiteSpace: "nowrap",
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //         }}
    //       >
    //         {dataIndex}
    //       </div>
    //     </Tooltip>
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      fixed: "right",
      width: 250,
      render: (e, record) => (
        <div className="SelectStatusSec">
          <Select
            value={e ? e : record.status}
            onChange={(e) => handleStatus(record.id, e)}
            defaultValue={e}
          >
            <Option value="Pending" disabled>
              {" "}
              <div className="discardopt">{t("pending")}</div>
            </Option>
            <Option value="Active">
              {" "}
              <div className="dealdoneopt">{t("active")}</div>
            </Option>
            <Option value="Inactive">
              {" "}
              <div className="contactedopt">{t("inactive")}</div>
            </Option>
          </Select>
        </div>
      ),
    },
    // {
    //   title: "Action",
    //   key: "operation",
    //   fixed: "right",
    //   width: 100,
    //   render: (text, record) => (
    //     <Space>
    //       <Tooltip
    //         color={colors}
    //         placement="left"
    //         title={<span style={{ color: "#fff" }}>Edit</span>}
    //       >
    //         <Link
    //           to={{
    //             pathname: "/pickup-point/edit/" + btoa(record.id),
    //           }}
    //         >

    //           <Editicon onClick={() => handleEdit(record.id)} />

    //         </Link>
    //       </Tooltip>
    //       <Tooltip
    //         color={colors}
    //         placement="right"
    //         title={<span style={{ color: "#fff" }}>Archive</span>}
    //       >
    //         <Popconfirm
    //           className="action"
    //           title={t("pop_title")}
    //           okText={t("pop_ok")}
    //           cancelText={t("pop_cancel")}
    //           onConfirm={() => handleArchive(record.id)}
    //         >
    //           <Archive style={{ cursor: "pointer" }} />
    //         </Popconfirm>
    //       </Tooltip>
    //     </Space>
    //   ),
    // },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const columnMenu = (
    <Menu>
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="person_name">Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="email">E-mail</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="address">Address</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="phone">Phone</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="state">State</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="suburb">Suburb</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="pincode">Pincode</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="additional_detail">Additional Detail</Checkbox>
            </Col>

            <Col span={12}>
              {/* <Checkbox value="operation" disabled>Action</Checkbox> */}
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const colors = ["#737373"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & manage the list of company within the organization.
                </span>
              }
            > */}
            <h3>Pickup Point Package</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Depo Manager Package")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Company To The Organization&apos;s Database.
                </span>
              }
            >
              <Button
                className="BlueShadowBtn"
                type="primary"
                onClick={() => navigate("/pickup-point/add")}
                icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
              >
                {t("Add Pickup Point")}
              </Button>
            </Tooltip> */}

            {/* {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_archive")}
                />
              </Popconfirm>
            )}
            <Tooltip placement="topLeft" title="View Archived Records">
              <Link className="Archiveicon" to="/pickup-point/archive">
                <Archiveicon />
              </Link>
            </Tooltip> */}
            {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={(e) => e.preventDefault()}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="PR-body">
          <Table
            rowSelection={rowSelection}
            columns={columns.filter((col) => !col.hidden)}
            rowKey={(record) => record.id}
            dataSource={pickupPointList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
            scroll={{
              x: 1000,
            }}
          />
        </div>
      </section>
    </>
  );
};
export default DepoManagerLoginList;
